import React from "react";
import LoanList from "./LoanList";

const Loan = () => {
  return (
    <div>
      <LoanList />
    </div>
  );
};

export default Loan;
